import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashClosureDetailDTO } from "../../../types/cash/cashClosure";

interface CashClosureState {

    closureStarted: boolean;

    closureId: number | null;
    closureNumber: string | null;

    expectedCash: number;
    totalSales: number;

    countedCash: number;
    difference: number;

    details: CashClosureDetailDTO[];

    observations: string;

    loading: boolean;

}

const initialState: CashClosureState = {

    closureStarted: false,

    closureId: null,
    closureNumber: null,

    expectedCash: 0,
    totalSales: 0,

    countedCash: 0,
    difference: 0,

    details: [],
    observations: "",

    loading: false

};

const cashClosureSlice = createSlice({

    name: "cashClosure",

    initialState,

    reducers: {

        /**
         * ▶️ Iniciar cierre
         */
        startClosure(
            state,
            action: PayloadAction<{
                id: number
                closureNumber: string
                expectedCash: number
                totalSales: number
            }>
        ) {

            state.closureStarted = true;

            state.closureId = action.payload.id;
            state.closureNumber = action.payload.closureNumber;

            state.expectedCash = action.payload.expectedCash;
            state.totalSales = action.payload.totalSales;

        },

        /**
         * ⛔ Finalizar cierre
         */
        finishClosure(state) {

            state.closureStarted = false;

            state.closureId = null;
            state.closureNumber = null;

            state.expectedCash = 0;
            state.totalSales = 0;

            state.countedCash = 0;
            state.difference = 0;

            state.details = [];
            state.observations = "";

        },

        /**
         * 🧾 Detalles
         */
        setDetails(state, action: PayloadAction<CashClosureDetailDTO[]>) {

            state.details = action.payload;

        },

        /**
         * 🧮 Resultado
         */
        updateResult(
            state,
            action: PayloadAction<{ countedCash: number, difference: number }>
        ) {

            state.countedCash = action.payload.countedCash;
            state.difference = action.payload.difference;

        },

        /**
         * ✏️ Observaciones
         */
        setObservations(state, action: PayloadAction<string>) {

            state.observations = action.payload;

        },

        /**
         * ⏳ Loading
         */
        setLoading(state, action: PayloadAction<boolean>) {

            state.loading = action.payload;

        }

    }

});

export const {

    startClosure,
    finishClosure,
    setDetails,
    updateResult,
    setObservations,
    setLoading

} = cashClosureSlice.actions;

export default cashClosureSlice.reducer;